export default {
  logout: "Выйти",
  Name: "Имя",
  Quantity: "Количество",
  BatchsPage: "Партии",
  CameraPage: "Камера",
  "Not Found": "Не найдено",
  Verification: "Проверка",
  "Verification passed": "Проверка пройдена",
  "Verification not passed": "Проверка не пройдена",
  Organization: "Организация",
  "Product group": "Группа продукта",
  "Product name": "Имя продукта",
  Region: "Регион",
  Series: "Серия",
  Status: "Статус",
  Volume: "Объем",
  stampProducedDate: "Дата производства печати",
  stampReceivedDate: "Дата получения штампа",
  EmployeePage: "Сотрудники",
  "Create employee": "Создать сотрудника",
  "Delete employee": "Удалить сотрудника",
  Surname: "Фамилия",
  Address: "Адрес",
  Enter: "Войти",
  Login: "Логин",
  Password: "Пароль",
  Submit: "Подтвердить",
  "Choose products": "Выберите продукт",
  "Choose quantity": "Выберите количество",
  "Next step": "Следующий шаг",
  "Make an order": "Сделать заказ",
  "Order is maked": "Заказ сделан",
  MarksPage: "Марки",
  Available: "Доступно",
  Date: "Дата",
  "Order ID": "ID очереди",
  "Product code": "Код товара",
  "Package code": "Код упаковки",
  notFoundPage: "Страница не найдена",
  "Profile page": "Профиль",
  "Company information": "Информация о компании",
  "Company BIN": "BIN компании",
  "Company name": "Имя компании",
  "Post code": "Почтовый код",
  Contacts: "Контакты",
  "Profile information": "Информация о профиле",
  "Mobile phone": "Мобильный телефон",
  Email: "Адрес электронной почты",
  ReportsPage: "Отчеты",
  ReviewPage: "Проверки",
  UKMPage: "УКМ",
  Number: "Номер",
  Profile: "Профиль",
  Reports: "Отчеты",
  Employee: "Сотрудники",
  Reviews: "Проверки",
  Batchs: "Партии",
  Marks: "Марки",
  Camera: "Камера",
  UKM: "УКМ",
  Orders: "Заказы",
  OrdersPage: "Заказы",
  Aggregations: "Агрегации",
  AggregationsPage: "Агрегации",
  Director: "Директор",
  "Name Surname": "Имя Фамилия",
  Checked: "Проверено",
  Generated: "Сгенерировано",
  "Mark ID": "ID марки",
  Logout: "Выйти",
  Code: "Код",
  Markings: "Маркировки",
  Marking: "Маркировка",
  "Enter manually": "Ввести вручную",
  "Use camera": "Использовать камеру",
  Find: "Найти",
  Yes: "Да",
  No: "Нет",
  Refresh: "Заново",
  january: "январь",
  february: "февраль",
  march: "март",
  april: "апрель",
  may: "май",
  june: "июнь",
  july: "июль",
  august: "август",
  september: "сентябрь",
  october: "октябрь",
  november: "ноябрь",
  december: "декабрь",
  in: "в",
  "Unused marks": "Неиспользованные марки",
  "New order": "Новый заказ",
  fio: "ФИО",
  "Confirm password": "Подтверждение пароля",
  Company: "Компания",
  GROUP: "Групповая потребительская упаковка",
  UNIT: "Единица товара",
  OPERATOR: "Автоматически",
  SELF_MADE: "Пользователем",
  "Enter by IIN": "Вход по ИИН",
  "Enter by ECP": "Вход по ЭЦП",
  "Don't have an account yet ?": "Еще нет аккаунта ?",
  "Register now": "Зарегистрироваться",
  "Select certificate": "Выберите сертификат",
  "Error connecting to interlayer": "Ошибка при подключении к прослойке",
  "Make sure the program is running and try again.":
    "Убедитесь что программа запущена и повторите попытку.",
  "Instructions for starting the program": "Инструкция по запуску программы",
  "Select document type": "Выберите тип документа",
  Cancel: "Отмена",
  "Enter the password for the certificate": "Введите пароль от сертификата",
  "Incorrect password": "Пароль неверен",
  "Enter password": "Введите пароль",
  "Attempts left": "Попыток осталось",
  "EDS for the identity card is blocked. Contact NAO GK `Government for citizens`":
    "ЭЦП на удостоверение личности заблокировано. Обратитесь в НАО ГК `Правительство для граждан`",
  "Select the certificate for authorization (with the AUTH prefix) and re-enter the password":
    "Выберите сертификат для авторизации (с префиксом AUTH) и повторно введите пароль",
  "Select the certificate to sign the application and re-enter the password":
    "Выберите сертификат для подписания заявки и повторно введите пароль",
  "A technical error has occurred. Please try again later.":
    "Произошла техническая ошибка. Повторите запрос позже.",
  "Select key": "Выберите ключ",
  Choose: "Выбрать",
  "Certificate data": "Данные сертификата",
  IIN: "ИИН",
  BIN: "БИН",
  "Name of company": "Наименование организации",
  Validity: "Срок действия",
  "Choose another certificate": "Выбрать другой сертифика",
  Step: "Шаг",
  "IIN/BIN of organization": "ИИН/БИН организации",
  "Legal verification": "Проверка юридических данных",
  'According to the Law of the Republic of Kazakhstan dated March 29, 2016 "On Amendments and Additions to Certain Legislative Acts of the Republic of Kazakhstan on the Issues of Reducing Permitting Documents and Simplifying Permitting Procedures", registration as an individual entrepreneur is carried out on the electronic licensing portal':
    "Согласно Закону Республики Казахстан от 29 марта 2016 года «О внесении изменений и дополнений в некоторые законодательные акты Республики Казахстан по вопросам сокращения разрешительных документов и упрощения разрешительных процедур» постановка на учет в качестве индивидуального предпринимателя осуществляется на портале электронного лицензирования",
  "Legal address": "Юридический адрес",
  "I agree to the processing of personal data":
    "Даю согласие на обработку персональных данных",
  "Back to": "Назад",
  ECP: "ЭЦП",
  "Become an entrepreneur": "Стать предпринимателем",
  "Personal data": "Персональные данные",
  phoneNumber: "Номер телефона",
  Complete: "Завершить",
  ismpt: "ИС МПТ",
  Token: "Токен",
  SUZ: "СУЗ",
  connected: "подключён",
  "not connected": "не подключён",
  Edit: "Изменить",
  Connect: "Подключить",
  "Edit employee": "Изменить сотрудника",
  Lines: "Линии",
  Attached: "Прикреплено",
  "Cancel delete": "Отменить удаление",
  Attach: "Прикрепить",
  Terminals: "Терминалы",
  Products: "Товары",
  productName: "Имя товара",
  amountBox: "Юнитов в коробе",
  amountPalette: "Коробов в палетте",
  createProduct: "Создать товар",
  Create: "Создать",
  productId: "ID товара",
  productGtin: "GTIN товара",
  Barcode: "Штрих-код",
  code: "код",
  Save: "Сохранить",
  productInformation: "Информация о товаре",
  Order: "Заказ",
  "Date of creation": "Дата создания",
  "Execution time (milliseconds)": "Время выполнения (миллисекунд)",
  "Product order ID": "ID продуктового заказа",
  "Contact name": "Имя контактного лица",
  "Preparation method": "Способ изготовления",
  "Codes total": "Кодов всего",
  "Codes received": "Кодов получено",
  "Get marking codes": "Получить коды маркировок",
  "Close suborder": "Закрыть подзаказ",
  Add: "Добавить",
  "Search by name": "Поиск по названию",
  Device: "Устройство",
  "Change production line": "Изменить пройзведственную линию",
  "Add production line": "Добавить пройзведственную линию",
  Devices: "Устройства",
  Line: "Линия",
  "New device": "Новое устройство",
  "Editing device": "Редактирование устройства",
  "Welcome to the Marking system": "Добро пожаловать в систему 'Маркировка'",
  "Follow these steps to get started": "Выполните следующие шаги чтобы начать",
  "Make your product page available in real time":
    "Сделайте страницу вашего продукта доступной в реальном времени",
  "Add your first product": "Добавить ваш первый товар",
  "Create an account": "Создайте учетную запись.",
  "You've already done it! It remains to complete the initial setup":
    "Вы уже сделали это! Осталось завершить первичную настройку.",
  "Add your first SKU": "Добавьте ваш первый SKU",
  "Store all product information in one place":
    "Храните всю информацию о продукте в одном месте.",
  "Download the Android app": "Загрузите Android приложение.",
  "Prepare your products for loading into the system":
    "Подготовте ваши товары к загрузке в систему.",
  "Print or request 'Marking' codes": "Распечетатайте или запросите коды.",
  "To start using the system right away please use your printer to print test codes Soon we will provide the ability to do this remotely":
    "Чтобы сразу начать пользоваться системой, пожалуйста, воспользуйтесь своим принтером для печати тестовых кодов. Скоро мы предоставим возможность делать это удаленно.",
  dt: "Дата",
  qty: "Количество",
  status: "Статус",
  available: "Доступно",
  barcode: "Штрих-код",
  "Export to excel": "Экспорт в Excel",
  PRODUCTION: "Производство в Казахстане",
  IMPORT: "Ввезен в Казахстан (Импорт)",
  REMAINS: "Маркировка остатков (доступно только для ТГ ‹Обувные товары›)",
  CROSSBORDER:
    "Ввезен в Казахстан из стран ЕАЭС (доступно только для ТГ ‹Обувные товары›)",
  "New document": "Новый документ",
  Receiver: "Получатель",
  Sender: "Отправитель",
  Documents: "Документы",
  DocumentsPage: "Документы",
  "Create document": "Создать документ",
  Invoice: "Накладная",
  Invoices: "Накладные",
  "Create invoice": "Создать накладную",
  "New invoice": "Новая накладная",
  "Add product": "Добавить продукт",
  "BIN of Receiver": "БИН получателя",
  signWithEcp: "Подписать с помощью ЭЦП",
  Outbox: "Исходящие",
  Inbox: "Входящие",
  addingProduct: "Добавление продукта",
  Product: "Продукт",
  "Method of forming serial goods": "Способ формирования серийного товара",
  "Method of release of goods into circulation":
    "Способ выпуска товаров в оборот",
  "Product type": "Тип товара",
  "Alcohol (unit)": "Алкоголь (единица)",
  "Alcohol (group packaging)": "Алкоголь (групповая упаковка)",
  Medicines: "Лекарства",
  "Cigarettes (block)": "Сигареты (блок)",
  "Cigarettes (package)": "Сигареты (пачка)",
  Shoes: "Обувь",
}
